import { styled } from "styled-components"

const ContentSection = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 32px;
    min-height: 100vh;
    background-color: ${({ theme }) => theme?.colors?.theme?.appBg};
`;

const SizeOfMenu = styled.div`
    height: 64px;
`;

const ContentWithMaxWidth = styled.div`
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 64px;
`
const LoaderContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
`;

const TextTitle = styled.p`
    width: 100%;
    max-width: 508px;
    margin: 0 auto;
    color: ${({ theme }) => theme?.colors?.text?.headings};
    text-align: center;
    font-family: "Red Hat Display", sans-serif;
    font-size: 32px;
    font-style: normal;
    font-weight: 900;
    line-height: 100%; /* 64px */
    span {
        color: ${({ theme }) => theme?.colors?.theme?.brandColor3};
        font-family: "Red Hat Display", sans-serif;
        font-style: normal;
        font-weight: 900;
        line-height: 100%; /* 64px */
    }
`;

const TextDescription = styled.p`
    max-width: 508px;
    margin: 0;
    color: ${({ theme }) => theme?.colors?.text?.headings};
    font-size: 48px;
    line-height: 100%;
    font-weight: 900;
    font-size: 20px;
    font-weight: 400;
    margin-top: 16px;
`;


export {
    ContentWithMaxWidth,
    LoaderContainer,
    ContentSection,
    SizeOfMenu,
    TextTitle,
    TextDescription
}
